import { DataResult } from '../model/DataResult';

/**
 * Selects the surplus ratio DataResult by priority order:
 * percentOfPHS → percentOfCAS → percentOfCurrentYear → percentOfTDP →
 * percentOfPYECAS → percentOfPYEPHS → percentOfCASPlusAVR
 *
 * These are mutually exclusive per subsection (a subsection sets exactly one surplus ratio flag),
 * so priority only matters as a tie-breaker; each maps to a single shared surplus column.
 *
 * Returns the first DataResult where value is not null, or undefined if all are null/undefined.
 */
export function selectSurplusRatio(fields: {
  percentOfPHS?: DataResult;
  percentOfCAS?: DataResult;
  percentOfCurrentYear?: DataResult;
  percentOfTDP?: DataResult;
  percentOfPYECAS?: DataResult;
  percentOfPYEPHS?: DataResult;
  percentOfCASPlusAVR?: DataResult;
}): DataResult | undefined {
  if (fields.percentOfPHS && fields.percentOfPHS.value !== null) {
    return fields.percentOfPHS;
  } else if (fields.percentOfCAS && fields.percentOfCAS.value !== null) {
    return fields.percentOfCAS;
  } else if (fields.percentOfCurrentYear && fields.percentOfCurrentYear.value !== null) {
    return fields.percentOfCurrentYear;
  } else if (fields.percentOfTDP && fields.percentOfTDP.value !== null) {
    return fields.percentOfTDP;
  } else if (fields.percentOfPYECAS && fields.percentOfPYECAS.value !== null) {
    return fields.percentOfPYECAS;
  } else if (fields.percentOfPYEPHS && fields.percentOfPYEPHS.value !== null) {
    return fields.percentOfPYEPHS;
  } else if (fields.percentOfCASPlusAVR && fields.percentOfCASPlusAVR.value !== null) {
    return fields.percentOfCASPlusAVR;
  }
  return undefined;
}
